import { DOWNLOAD_INVOICE_OR_RECEIPT, DOWNLOAD_FILE } from "../actions/actionTypes";
import { updateActionErrors } from "./updateErrors";
import { JsonRestClient } from "../../api/rest_interceptor";
import fileDownload from "js-file-download";
import { Capacitor } from "@capacitor/core";
import { Filesystem, Directory } from "@capacitor/filesystem";
import { Share } from "@capacitor/share";
import { Toast } from "@capacitor/toast";
import writeBlob from "capacitor-blob-writer";

const blobToBase64 = (blob) => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
        const dataUrl = reader.result || '';
        const base64 = String(dataUrl).split(',')[1] || '';
        resolve(base64);
    };
    reader.onerror = reject;
    reader.readAsDataURL(blob);
});

const inferMimeType = (fileName) => {
    const ext = (fileName.split('.').pop() || '').toLowerCase();
    switch (ext) {
        case 'pdf': return 'application/pdf';
        case 'csv': return 'text/csv';
        case 'xlsx': return 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
        case 'xls': return 'application/vnd.ms-excel';
        case 'png': return 'image/png';
        case 'jpg':
        case 'jpeg': return 'image/jpeg';
        default: return 'application/octet-stream';
    }
}

async function handleNativeDownload(blob, fileName) {
    try {
        const isAndroid = Capacitor.getPlatform && Capacitor.getPlatform() === 'android';
        const mimeType = inferMimeType(fileName);
        if (isAndroid) {
            // Write via MediaStore into public Downloads
            await writeBlob({
                path: `Download/${fileName}`,
                blob,
                directory: Directory.ExternalStorage,
                recursive: true,
            });
            try {
                await Toast.show({ text: `Saved to Downloads/${fileName}` });
            } catch (_) {}
        } else {
            // iOS: write into app Documents
            const typedBlob = blob.type ? blob : new Blob([blob], { type: mimeType });
            const base64Data = await blobToBase64(typedBlob);
            await Filesystem.writeFile({
                path: `${fileName}`,
                data: base64Data,
                directory: Directory.Documents,
                recursive: true,
            });
            // Present native share so user can export/save to Files
            try {
                const uri = await Filesystem.getUri({ path: `${fileName}`, directory: Directory.Documents });
                if (uri && uri.uri) {
                    await Share.share({ title: fileName, url: uri.uri });
                }
            } catch (_) {}
        }
    } catch (err) {
        console.log('Unable to save file', err);
    }
}

const downloadMiddleware = store => next => async action => {
    let payload = action.payload;
    let data;
    switch (action.type) {
        case DOWNLOAD_INVOICE_OR_RECEIPT:
            data = {
                transaction_document: payload.transactionType,
                transaction_id: payload.transactionId
            };
            try {
                await JsonRestClient.post(`api/tenant_transaction_document/download`,
                    data, { responseType: 'blob' }).then((response) => {
                        let fileName = `${payload.transactionType}.pdf`
                        if (response.headers['content-disposition']){
                            fileName = response.headers['content-disposition'].split("filename=")[1].slice(1, -1)
                        }
                        if (Capacitor.getPlatform() !== 'web') {
                            const mimeType = inferMimeType(fileName);
                            const dataBlob = (response.data instanceof Blob && response.data.type)
                                ? response.data
                                : new Blob([response.data], { type: mimeType });
                            handleNativeDownload(dataBlob, fileName);
                        } else{
                            fileDownload(response.data, fileName);
                        }
                    })

            } catch (error) {
                console.error(error);
                action = updateActionErrors(action, error)
            }
            break;
        case DOWNLOAD_FILE:
            data = {
                itemType: payload.itemType,
                fileId: payload.fileId
            };
            try {
                await JsonRestClient.post(`api/files/download`,
                    data, { responseType: 'blob' }).then((response) => {
                        let fileName = payload.fileName;
                        if (response.headers['content-disposition']){
                            fileName = response.headers['content-disposition'].split("filename=")[1].slice(1, -1)
                        }
                        if (Capacitor.getPlatform() !== 'web') {
                            const mimeType = inferMimeType(fileName);
                            const dataBlob = (response.data instanceof Blob && response.data.type)
                                ? response.data
                                : new Blob([response.data], { type: mimeType });
                            handleNativeDownload(dataBlob, fileName);
                        } else {
                            fileDownload(response.data, fileName);
                        }
                    })

            } catch (error) {
                console.error(error);
                action = updateActionErrors(action, error)
            }
            break;
        default:
            break;
    }

    return next(action);
};

export {
    downloadMiddleware
}